module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'cz57x2ws',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
